import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import axios from "axios";
import config from "../config";

const BACKEND_URL = config.backend.host;

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);

export default function FileUpload(props) {
  // console.log("MAXFILES: ", props);
  const [files, setFiles] = useState([]);
  // const token = Token.getToken();
  const handlePondFile = (error, file) => {
    if (error) {
      // console.log('Oh no', error);
      return;
    }
    // console.log('File added', file);
  };

  const processFile = (
    fieldName,
    file,
    metadata,
    load,
    error,
    progress,
    abort
  ) => {
    // FormData is a Web API that creates a HTML <form> element.
    const formData = new FormData();
    formData.append("image", file, file.name);
    // the request itself
    axios
      .post(BACKEND_URL + "/upload", formData, {
        onUploadProgress: (e) => {
          // updating progress indicator
          progress(e.lengthComputable, e.loaded, e.total);
        },
      })
      .then((response) => {
        // passing the file id to Filepond
        props.updateLinks("add", response.data.fileUrl);
        load(response.data.fileUrl);
      })
      .catch((e) => proccessError(e));

    // Should expose an abort method so the request can be cancelled
    return {
      // this function is called if the user has tapped the cancel button.
      abort: () => {
        // source.cancel("Operation cancelled by the user.");
      },
    };
  };

  const proccessError = (e) => {
    if (e.response) {
      if (e.response.status === 422) {
        alert(
          `Error uploading file: It looks like your conection is too slow to upload a file of this size.`
        );
        // console.log("ERR", e);
        // console.log("ERR", e.response);
      } else {
        alert(
          `Error uploading file: ${e} | Response: ${
            e.response ? e.response.data.message : e.response.message
          }`
        );
        // console.log("ERR", e);
        // console.log("ERR", e.response);
      }
    } else {
      alert(`Error uploading file: ${e} | Response: No Response`);
      // console.log("ERR", e);
    }
  };

  return (
    <div className="App">
      <FilePond
        files={files}
        allowMultiple={true}
        acceptedFileTypes={"image/jpeg, image/png"}
        onupdatefiles={setFiles}
        maxFiles={props.maxFiles ? props.maxFiles : 2}
        allowRevert={false}
        labelIdle='Drag & Drop your images or <span class="filepond--label-action">Browse</span>'
        server={{
          timeout: 30000,
          process: (
            fieldName,
            file,
            metadata,
            load,
            error,
            progress,
            abort
          ) => {
            processFile(
              fieldName,
              file,
              metadata,
              load,
              error,
              progress,
              abort
            );
          },
          revert: (uniqueFileId, load, error) => {
            props.updateLinks("remove", uniqueFileId);
            // Should remove the earlier created temp file here
            // ...

            // Can call the error method if something is wrong, should exit after
            error("Error");

            // Should call the load method when done, no parameters required
            load();
          },
        }}
        onprocessfile={handlePondFile(this)}
      />
    </div>
  );
}
